// Entry point. auth.js must load first - it wires up window.IT_AUTH, which
// every view's API calls go through.
import './auth.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Root } from './app.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(<Root />);
